var _polygon, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpeakerMuted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-volume-x"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 22,
  x2: 16,
  y1: 9,
  y2: 15
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 16,
  x2: 22,
  y1: 9,
  y2: 15
})));
export default SvgSpeakerMuted;